// プロダクト情報クラス
import { CanvasData } from '@/js/CanvasData.js'
//import Zlib from 'zlib'
import JSZip from 'jszip'
//import Vue from 'vue'
//import axios from 'axios'
import { OffScreen } from '@/js/OffScreen.js'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import { User } from '@/js/User.js'
import { Common } from '@/js/common.js'
import { GetCanvasSize, GetAcryProductPrice, ProductId } from '@/js/Const.js'
import { FirebaseCommon } from './FirebaseCommon'
//import { RealtimeDatabaseTableName } from "@/js/Const.js";
import { Logger } from '@/js/utils/Logger.js'
import { CreateFrameCutlineImage, ConvertSvgToPng, CreateImageElement, ReplacePngColor } from "@/js/CommonFunc.js";


export default class ProductData {
    constructor(saleProductData, categoryData) {
        Logger.info("saleProductData");
        Logger.debug(saleProductData);
        Logger.debug(categoryData);
        this.saleProductData = saleProductData
        this.categoryData = categoryData
        this.tagInfo = "noTag"
        this.price = categoryData['price02']
        this.printInfo = "front"
        this.quantity = 1
        this.whiteCount = 0
        this.productId = saleProductData.productId
        this.productName = saleProductData.productName
        this.tagTemplateName = "Sample"
        let S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let N = 16
        this.id = Array.from(Array(N)).map(() => S[Math.floor(Math.random() * S.length)]).join('')
        this.cartId = "" // カートから編集された場合
        this.draftId = ""   // 下書きから編集された場合
        return this
    }

    /**
     * キャンバスサイズの取得
     */
    getCanvasSizes() {
        // プロダクトID + classcategory_id2
        var canvasSizes = []
        canvasSizes = GetCanvasSize(this.productId)
        return canvasSizes
    }

    /**
     * 表裏セットÏ
     * @param {表裏} info 
     */
    setPrintInfo(info) {
        console.log(info)
        this.printInfo = info
        switch (info) {
            case "front":
                this.canvasDatas = [new CanvasData(this, info, this.getCanvasSizes())];
                this.frontPrintPrice = 100
                this.backPrintPrice = 0

                break;
            case "back":
                this.canvasDatas = [new CanvasData(this, info, this.getCanvasSizes())];
                this.frontPrintPrice = 0
                this.backPrintPrice = 100

                break;
            case "frontback":
                this.canvasDatas = [new CanvasData(this, "front", this.getCanvasSizes()), new CanvasData(this, "back", this.getCanvasSizes())];
                this.frontPrintPrice = 100
                this.backPrintPrice = 100

                break;
        }
        this.tagCanvasData = new CanvasData(this, "tag")
    }

    /**
     * JSONファイルからProductDataを復元する際に使用
     * ProductDataクラス作成後すぐにこれを呼ぶイメージ
     * 画像の設定はVue側で行いStoreへの保存もVue側で行う
     */
    async createDataForJson( info, designId ){
        // 各変数の設定
        this.quantity = parseInt(info.productJson.quantity);
        this.tagInfo = info.productJson.tagInfo;
        this.setPrintInfo(info.productJson.printInfo);
        this.tagTemplateName = info.productJson.tagTemplateName;
        this.whiteCount = info.productJson.whiteCount;
        this.isShareCodeDraft = info.productJson.isShareCodeDraft;
        // テキストアイテムの設定
        await this.canvasDatas[0].updateInfo(info.productJson.canvasDatas[0], designId, info.zipData)
    }

    setCartId(id){
        this.cartId = id;
    }

    setDraftId(id){
        this.draftId = id;
    }

    getImagePath() {
        //console.log("@/assets/" + this.saleProductData.productId + ".jpg")
        return require("@/assets/" + this.saleProductData.productId + ".jpg");
    }
    removeCanvasData(canvasData, store) {
        if (canvasData === store.state.currentCanvasData) {
            store.commit("selectCanvasData", null)
        }

        if (this.printInfo == "frontback") {
            if (canvasData == this.canvasDatas[0]) {
                this.printInfo = "back"
            }
            if (canvasData == this.canvasDatas[1]) {
                this.printInfo = "front"
            }
        }
        this.canvasDatas = this.canvasDatas.filter(function (a) {
            return a !== canvasData;
        });
    }
    addCanvas() {
        if (this.printInfo == "front") {
            let cdata = new CanvasData(this, "back", this.getCanvasSizes())
            this.canvasDatas.push(cdata)
            this.printInfo = "frontback"
            return cdata
        } else if (this.printInfo == "back") {
            let cdata = new CanvasData(this, "front", this.getCanvasSizes())
            this.canvasDatas.unshift(cdata)
            this.printInfo = "frontback"
            return cdata
        }
    }
    /**
     * 商品名称の作成
     */
    getProductName() {
        return this.productName
    }
    /**
     * C02用連想配列作成
     */
    async getProductData() {
        let frontImagePath = ''
        // let backImagePath = ''
        let front_previewPath = null
        // let back_previewPath = null
        if (this.frontImageName != '') {
            frontImagePath = await firebase
                .storage()
                .ref()
                .child(firebase.auth().currentUser.uid + "/" + this.frontImageName)
                .getDownloadURL()

            front_previewPath = await FirebaseCommon.getImageUrl(
                "history_front_" + this.id + ".png"
            ).catch(() => {

            })
        }
        // if (this.backImageName != '') {
        //     backImagePath = await firebase
        //         .storage()
        //         .ref()
        //         .child(firebase.auth().currentUser.uid + "/" + this.backImageName)
        //         .getDownloadURL()
        //     back_previewPath = await FirebaseCommon.getImageUrl(
        //         "history_back_" + this.id + ".png"
        //     ).catch(() => {

        //     })
        // }

        let pinfo = "front"
        if (this.canvasDatas[0].itemList.length > 0) {
            pinfo += "front"
        }
        // if (this.canvasDatas[1].itemList.length > 0) {
        //     pinfo += "back"
        // }
        let data = {
            product_id: this.saleProductData.productId,
            product_name: this.getProductTitle(),
            product_info: pinfo,
            front_image_path: frontImagePath ? frontImagePath : "",
            front_image_path_mono: frontImagePath ? frontImagePath : "",
            front_image_path_preview: front_previewPath ? front_previewPath : "",
            front_image_path_outline: "",
            front_rib: 0,
            // back_image_path: backImagePath ? backImagePath : "",
            // back_image_path_mono: backImagePath ? backImagePath : "",
            // back_image_path_preview: back_previewPath ? back_previewPath : "",
            back_rib: 0,
            tag_type: "0",
            tag_image_path: "",
            tag_image_path_mono: "",
            product_price: this.categoryData["price02"] == '' ? "700" : this.categoryData["price02"] / (Common.getTax() + 1.0),
            // 前面印刷価格
            paint_price_1: this.getFrontPrice().toFixed(),
            // 後面印刷価格
            paint_price_2: this.getBackPrice().toFixed(),
            // タグ価格
            tag_price: this.getTagPrice().toFixed(),
            // 数量
            quantity: this.quantity,
            // マージン抜きの商品価格(税抜き)
            price_base: this.getOnePrice(),
            // マージン額税抜き
            margin: this.getOneMarginPrice(),
            // マージン額税込
            margin_inctax: this.getOneMarginPrice() + this.getOneMarginTax(),
            // 税率(%)
            tax_rate: (Common.getTax() * 100).toFixed(),
            // 税額
            tax: this.getProductTaxWithoutMargin() + this.getMarginTax(),
            // マージン込みの商品代金(税抜き)
            price: ((this.getPrice() + this.getMarginPrice()) / this.quantity).toFixed(),
            // マージン込みの商品代金(税込)
            price_inctax: ((this.getPrice() + this.getMarginPrice() + this.getProductTaxWithoutMargin() + this.getMarginTax()) / this.quantity).toFixed(),
            product_class_id: Number(this.categoryData.product_class_id),
            classcategory_id1: Number(this.categoryData.classcategory_id1),
            classcategory_id2: Number(this.categoryData.classcategory_id2),
        }
        return data
    }

    // アクリル商品の購入API送信用データ
    async getProductItemData( itemIndex ) {
        let frontImagePath = this.acrylFile[itemIndex].design;
        let frontMonoImagePath = this.acrylFile[itemIndex].mono;
        let frontPreviewImagePath = this.acrylFile[itemIndex].preview;
        let frontCutlineImagePath = this.cutlineFilePath;

        let data = {
            product_id: this.saleProductData.productId,
            product_name: this.getProductTitle(),
            product_info: "front",
            front_image_path: frontImagePath,
            front_image_path_mono: frontMonoImagePath,
            front_image_path_preview: frontPreviewImagePath,
            front_image_path_outline: frontCutlineImagePath,
            back_image_path: "",
            back_image_path_mono: "",
            back_image_path_preview: "",
            front_rib: 0,
            back_rib: 0,
            tag_type: "0",
            tag_image_path: "",
            tag_image_path_mono: "",
            product_price: this.getOnePrice(),
            // 前面印刷価格
            paint_price_1: this.getFrontPrice().toFixed(),
            // 後面印刷価格
            paint_price_2: this.getBackPrice().toFixed(),
            // タグ価格
            tag_price: this.getTagPrice().toFixed(),
            // 数量
            quantity: 1,
            // マージン抜きの商品価格(税抜き)
            price_base: this.getOnePrice(),
            // マージン額税抜き
            margin: this.getOneMarginPrice(),
            // マージン額税込
            margin_inctax: this.getOneMarginPrice() + this.getOneMarginTax(),
            // 税率(%)
            tax_rate: (Common.getTax() * 100).toFixed(),
            // 税額
            tax: this.getProductTaxWithoutMargin() + this.getMarginTax(),
            // マージン込みの商品代金(税抜き)
            price: ((this.getPrice() + this.getMarginPrice()) / this.quantity).toFixed(),
            // マージン込みの商品代金(税込)
            price_inctax: ((this.getPrice() + this.getMarginPrice() + this.getProductTaxWithoutMargin() + this.getMarginTax()) / this.quantity).toFixed(),
            product_class_id: Number(this.categoryData.product_class_id),
            classcategory_id1: Number(this.categoryData.classcategory_id1),
            classcategory_id2: Number(this.categoryData.classcategory_id2),
        }
        console.log(data)
        return data
    }

    // AcryPrintの購入API送信用データ
    async getProductItemDataAcryPrint( itemIndex ) {
        let frontImagePath = this.acrylFile[itemIndex].design;
        let frontMonoImagePath = this.acrylFile[itemIndex].mono;
        let frontPreviewImagePath = this.acrylFile[itemIndex].preview;

        let size = "S";
        switch(this.productId){
            case ProductId.ACRY_PRINT_S: size = "S"; break;
            case ProductId.ACRY_PRINT_M: size = "M"; break;
            case ProductId.ACRY_PRINT_L: size = "L"; break;
        }

        let dymmyMonoImagePath = await FirebaseCommon.getDummyMonoImage(size);
        console.log("dummy");
        console.log(size);
        console.log(dymmyMonoImagePath);

        let data = {
            product_id: this.saleProductData.productId,
            product_name: this.getProductTitle(),
            product_info: "front",
            front_image_path: frontImagePath,
            front_image_path_mono: dymmyMonoImagePath,
            front_image_path_preview: frontPreviewImagePath,
            front_image_path_outline: "",
            back_image_path: frontMonoImagePath,
            back_image_path_mono: "",
            back_image_path_preview: "",
            front_rib: 0,
            back_rib: 0,
            tag_type: "0",
            tag_image_path: "",
            tag_image_path_mono: "",
            product_price: this.getOnePrice(),
            // 前面印刷価格
            paint_price_1: this.getFrontPrice().toFixed(),
            // 後面印刷価格
            paint_price_2: this.getBackPrice().toFixed(),
            // タグ価格
            tag_price: this.getTagPrice().toFixed(),
            // 数量
            quantity: 1,
            // マージン抜きの商品価格(税抜き)
            price_base: this.getOnePrice(),
            // マージン額税抜き
            margin: this.getOneMarginPrice(),
            // マージン額税込
            margin_inctax: this.getOneMarginPrice() + this.getOneMarginTax(),
            // 税率(%)
            tax_rate: (Common.getTax() * 100).toFixed(),
            // 税額
            tax: this.getProductTaxWithoutMargin() + this.getMarginTax(),
            // マージン込みの商品代金(税抜き)
            price: ((this.getPrice() + this.getMarginPrice()) / this.quantity).toFixed(),
            // マージン込みの商品代金(税込)
            price_inctax: ((this.getPrice() + this.getMarginPrice() + this.getProductTaxWithoutMargin() + this.getMarginTax()) / this.quantity).toFixed(),
            product_class_id: Number(this.categoryData.product_class_id),
            classcategory_id1: Number(this.categoryData.classcategory_id1),
            classcategory_id2: Number(this.categoryData.classcategory_id2),
        }
        console.log(data)
        return data
    }

    toJson() {
        var canvasListJson = []
        this.canvasDatas.forEach(function (canvasData) {
            canvasListJson.push(canvasData.getProperty())
        })

        return JSON.stringify({
            id: this.id,
            productId: this.saleProductData.productId,
            productName: this.getProductTitle(),
            count: this.count,
            size: this.size,
            color: this.color,
            price: this.price,
            tagInfo: this.tagInfo,
            printInfo: this.printInfo,
            colorType: this.colorType,
            canvasDatas: canvasListJson,
            classcategory_id1: this.saleProductData.classcategory_id1,
            classcategory_id2: this.saleProductData.classcategory_id2,
            tagCanvasData: this.tagCanvasData.getProperty(),
            tagTemplateName: this.tagTemplateName ? this.tagTemplateName : "",
            whiteCount: this.whiteCount,
            quantity: this.quantity,
            isShareCodeDraft: this.isShareCodeDraft,
        })
    }
    /**
     * 税率
     */
    getTax() {
        return 0.1
    }
    getCanvasItemBlob(canvasitem) {
        return new Promise(function (resolve) {
            let imgW = canvasitem.imageobj.width
            let imgH = canvasitem.imageobj.height

            let offs = new OffScreen(imgW, imgH)
            offs.drawImage(canvasitem.imageobj, 0, 0, imgW, imgH)

            var callbackFunction = function (result) {
                resolve(result)
            };
            offs.toBlob(callbackFunction)
        })
    }

    // 注文する際に使用
    // 画像の生成、アップロード、URLの取得を担当
    async uploadDesignData(progressCallback) {
        const results = [];

        // ZIP + this.quantityのアップロードダウンロード
        // 全体の作業量をざっくり計算
        const dataAmount = 3 + this.quantity * 5;
        let processed = 0;

        // zipのデータは完全に分離可能なため処理ごと分離
        results.push(this.uploadProductZipFile( function(){
            processed += 3;
            progressCallback( 100 / dataAmount * processed );
        } ));

        // 処理を非同期で行うために
        // 1. 画像生成
        // 2. 画像アップロード
        // 3. 画像URL取得
        // に処理を分割する
        Logger.info("uploadProductDataCreateImages");
        await this.uploadProductDataCreateImages(function(){
            processed += 4;
            progressCallback( 100 / dataAmount * processed );
        } );

        Logger.info("uploadProductDataGetImageUrls");
        await this.uploadProductDataGetImageUrls(function(){
            processed += 1;
            progressCallback( 100 / dataAmount * processed );
        } );

        await Promise.all(results);
    }

    async uploadProductZipFile( callback ){
        const zipData = this.makeZipData();
        let zipBlob = await this.makeZipBlob(zipData)
        await this.uploadZipFile(zipBlob, FirebaseCommon.getZipFileName(this.id));
        callback();
        this.zipFilePath = await FirebaseCommon.getImageUrl(FirebaseCommon.getZipFileName(this.id)).catch(() => {});
    }

    async uploadProductDataCreateImages( callback ){
        const data = {};
        data.images = [];

        const results = [];

        // デザイン画像
        // results.push(this.canvasDatas[0].createDesignBlob((blob)=>{data.designImage = blob}));
        data.designImage = this.canvasDatas[0].designImageFile;
        data.cutlineImage = this.canvasDatas[0].cutlineImageFile;

        // プレビュー画像用のカットライン画像を生成
        const pngSvg = await ConvertSvgToPng(URL.createObjectURL(data.cutlineImage), this.productId);
        let frameCutline = await CreateFrameCutlineImage(pngSvg);
        frameCutline = await ReplacePngColor(URL.createObjectURL(frameCutline), "#000000");
        data.previewImage = await this.canvasDatas[0].createDesignAndCutlineBlob(await CreateImageElement(frameCutline));

        await Promise.all(results);
        results.splice();

        // デザイン画像のアップロード
        results.push(this.uploadPngImageFile(data.designImage, FirebaseCommon.getDesignFileName(this.id)));
        if(this.isShareCodeDraft){
            results.push(this.uploadPngImageFile(data.cutlineImage, FirebaseCommon.getPngCutlineFileName(this.id)), true);
        }else{
            results.push(this.uploadSvgImageFile(data.cutlineImage, FirebaseCommon.getSvgCutlineFileName(this.id)));
        }

        // プレビュー用(カットライン付き)
        results.push(this.uploadPngImageFile(data.previewImage, FirebaseCommon.getPreviewFileName(this.id)));

        for( let i = 0; i<this.quantity; ++i ) {
            await this.uploadAcrylImage(i, results);
            callback();
        }

        await Promise.all(results);
    }

    async uploadAcrylImage(index, results){
        const imageBlob = await this.canvasDatas[0].createAcrylImageBlob(index);
        results.push( this.uploadPngImageFile(imageBlob.designImage, FirebaseCommon.getFrontFileName(this.id, index)))
        results.push( this.uploadPngImageFile(imageBlob.monoImage, FirebaseCommon.getFrontMonoFileName(this.id, index), true))
    }

    async uploadProductDataGetImageUrls( callback ){
        const results = [];

        // デザイン
        results.push( FirebaseCommon.getImageUrl(FirebaseCommon.getDesignFileName(this.id)).then(
            (url)=>{ this.designFilePath = url; }));

        // カットライン画像
        if(this.isShareCodeDraft){
            results.push( FirebaseCommon.getImageUrl(FirebaseCommon.getPngCutlineFileName(this.id)).then(
                (url)=>{ this.cutlineFilePath = url; }));
        }else{
            results.push( FirebaseCommon.getImageUrl(FirebaseCommon.getSvgCutlineFileName(this.id)).then(
                (url)=>{ this.cutlineFilePath = url; }));
        }

        results.push( FirebaseCommon.getImageUrl(FirebaseCommon.getPreviewFileName(this.id)).then(
            (url)=>{ this.previewFilePath = url; }));


        var images = Array.from({ length: this.quantity });
        for( let i = 0; i<images.length; ++i ){
            images[i] = {};
        }

        for( let i = 0; i<this.quantity; ++i ) {
            //let index = i;
            const self = this;
            results.push(
                FirebaseCommon.getImageUrl(FirebaseCommon.getFrontFileName(self.id, i)).then(
                    (path)=>
                    {
                        images[i].designPath = path;
                    })
            );
            results.push(
                FirebaseCommon.getImageUrl(FirebaseCommon.getFrontMonoFileName(self.id, i)).then(
                    (path)=>
                    {
                        callback();
                        images[i].monoPath = path;
                    })
            );
        }

        await Promise.all(results);

        this.acrylFile = [];

        // 注文個数分デザイン画像を生成
        for( let i = 0; i<this.quantity; ++i ) {
            var designPath = images[i].designPath;
            var monoPath = images[i].monoPath;
            var previewPath = designPath;
            this.acrylFile.push({
                "design":designPath,
                "mono":monoPath,
                "preview":previewPath,
            });
        }
    }

    async registDatabase() {

        // プロダクトのZIP周りをアップロード
        // アイテムの配置データテキストデータ等
        await this.uploadDesignData()


        // 注文履歴に使用
        // TODO:あとで直す
        // let self = this
        // var ref = firebase.database().ref(RealtimeDatabaseTableName.HistoryData + "/" + firebase.auth().currentUser.uid);
        // ref.once("value", function (snapshot) {
        //     /* ここに取得したデータを用いた何らかの処理 */
        //     let products = []
        //     if (snapshot.val()) {
        //         products = snapshot.val()
        //     }

        //     let data = {}
        //     data["historyId"] = self.id
        //     data["productId"] = self.productId
        //     data["productName"] = self.getProductTitle()
        //     data["classcategory_id1"] = self.categoryData.classcategory_id1
        //     data["classcategory_id2"] = self.categoryData.classcategory_id2
        //     data["productId"] = self.productId
        //     data["tagtemplate"] = self.tagTemplateName ? self.tagTemplateName : ""
        //     data["tagInfo"] = self.tagInfo
        //     data["createDate"] = Common.getStringFromDate(new Date())
        //     data["orderId"] = ""
        //     data["isSaveHistory"] = isSaveHistory
        //     data["bikou"] = bikou

        //     products.push(data)
        //     ref.set(products)
        //     if (progressCallback) {
        //         progressCallback(1)
        //     }
        // })
    }

    async registEstimatesDatabase(progressCallback = null) {

        // await this.uploadDesignData(true,(progress, sendBytes) => {
        //     if (progressCallback) {
        //         progressCallback(0.9 * progress, sendBytes)
        //     }
        // })
        // let self = this
        // var ref = firebase.database().ref('EstimatesData/' + firebase.auth().currentUser.uid);
        // ref.once("value", function (snapshot) {
        //     /* ここに取得したデータを用いた何らかの処理 */
        //     let products = []
        //     if (snapshot.val()) {
        //         products = snapshot.val()
        //     }

        //     let data = {}
        //     data["historyId"] = self.id
        //     data["productId"] = self.productId
        //     data["productName"] = self.getProductTitle()
        //     data["classcategory_id1"] = self.categoryData.classcategory_id1
        //     data["classcategory_id2"] = self.categoryData.classcategory_id2
        //     data["productId"] = self.productId
        //     data["tagtemplate"] = self.tagTemplateName ? self.tagTemplateName : ""
        //     data["tagInfo"] = self.tagInfo
        //     data["createDate"] = Common.getStringFromDate(new Date())
        //     data["orderId"] = ""
        //     data["isSaveHistory"] = true


        //     products.push(data)
        //     ref.set(products)
        //     if (progressCallback) {
                 progressCallback(1)
        //     }
        // })
    }
    strToUtf8Array(str) {
        var n = str.length,
            idx = -1,
            bytes = [],
            i, c;
        for (i = 0; i < n; ++i) {
            c = str.charCodeAt(i);
            if (c <= 0x7F) {
                bytes[++idx] = c;
            } else if (c <= 0x7FF) {
                bytes[++idx] = 0xC0 | (c >>> 6);
                bytes[++idx] = 0x80 | (c & 0x3F);
            } else if (c <= 0xFFFF) {
                bytes[++idx] = 0xE0 | (c >>> 12);
                bytes[++idx] = 0x80 | ((c >>> 6) & 0x3F);
                bytes[++idx] = 0x80 | (c & 0x3F);
            } else {
                bytes[++idx] = 0xF0 | (c >>> 18);
                bytes[++idx] = 0x80 | ((c >>> 12) & 0x3F);
                bytes[++idx] = 0x80 | ((c >>> 6) & 0x3F);
                bytes[++idx] = 0x80 | (c & 0x3F);
            }
        }
        return bytes;
    }
    /**
     * マージンを除いた商品代の税抜き金額
     */
    getPrice() {
        let price = this.getOnePrice() * this.quantity
        return price
    }
    getOnePrice() {
        return GetAcryProductPrice(this.productId).priceBase;
        // return Math.ceil((this.getFrontPrice() + this.getBackPrice() + this.getTagPrice() + Number(this.categoryData["price02"] == '' ? "700" : this.categoryData["price02"].replace(/,/g, '') / (Common.getTax() + 1.0))))
        //return Math.ceil((this.getFrontPrice() + this.getBackPrice() + this.getTagPrice() + Number(this.categoryData["price02"] == '' ? "700" : this.categoryData["price02"] / (Common.getTax() + 1.0))))
    }
    getTagPrice() {
        return 0
    }
    getFrontPrice() {
        return 0
    }
    getBackPrice() {
        return 0
    }
    // マージンを除いた商品の消費税額(切り上げ)
    getProductTaxWithoutMargin() {
        return Math.ceil(this.getPrice() * Common.getTax())
    }
    getMarginPrice() {
        if (this.getFrontPrice() == 0 && this.getBackPrice() == 0) {
            return 0
        }
        return this.getOneMarginPrice() * this.quantity
    }
    getOneMarginPrice() {
        return Math.ceil((this.getOnePrice() * (Number(User.userData.introduced_margin) / 100)))
    }
    getMarginTax() {
        return 0
    }
    getOneMarginTax() {
        return 0
    }

    // 面積に応じた料金表
    caluculatePaintedAreaPrice() {
        return 0
    }

    normalize(val) {
        if (val > 1) {
            return 1
        } else {
            return val
        }
    }

    getProductTitle() {
        return this.productName
    }
    // 違う色でプロダクトをコピー
    async copyProduct(newCategoryData, whiteInfo) {
        let p = new ProductData(
            this.saleProductData,
            newCategoryData
        )
        p.quantity = 1
        p.tagInfo = this.tagInfo
        p.setPrintInfo(this.printInfo)
        p.tagTemplateName = this.tagTemplateName
        p.frontTagPath = this.frontTagPath
        p.backTagPath = this.backTagPath
        p.tagPath = this.tagPath
        p.whiteCount = whiteInfo

        // キャンバスデータのコピー
        p.canvasDatas[0] = await this.canvasDatas[0].copy(p)
        p.canvasDatas[1] = await this.canvasDatas[1].copy(p)
        return p

    }


    // =========================== //
    //      アップロード周り名関連     //
    // =========================== //
    // async uploadPngImageFile(blobimage, fileName, progressCallback = null) {
    //     let beforeBytes = 0
    //     return new Promise((resolve) => {
    //         var storageRef = firebase.storage().ref(FirebaseCommon.getBaseFilePath() + fileName);
    //         const file = new File([blobimage], fileName, { type: "image/png" })
    //         let upload = storageRef.put(file)
    //         upload.on('state_changed', function (snapshot) {
    //             if (progressCallback) {
    //                 var progress = (snapshot.bytesTransferred / snapshot.totalBytes);
    //                 progressCallback(progress, snapshot.bytesTransferred - beforeBytes)
    //                 beforeBytes = snapshot.bytesTransferred
    //             }
    //         }, function (error) {
    //             console.log(error)
    //         }, function () {
    //             resolve()
    //         });
    //     })
    // }
    async uploadPngImageFile(blobimage, fileName, isMono = false) {
        let filePath = FirebaseCommon.getBaseFilePath() + fileName;

        return new Promise((resolve) => {
            var storageRef = firebase.storage().ref(filePath);
            const file = new File([blobimage], fileName, { type: "image/png" })
            let upload = storageRef.put(file)
            upload.on('state_changed', function (snapshot) {
                console.log(snapshot);
            }, function (error) {
                console.log(error)
            }, function () {
                if( !isMono )
                {
                    // デザインの場合はここで終了
                    resolve();
                    return;
                }

                // mono画像の場合は追加でグレースケール処理
                const functions = firebase.functions();
                const func = functions.httpsCallable("ColorspaceToGray");
                func({
                    fromPath: filePath,
                    toPath: filePath,
                }).then( ()=>{
                    resolve();
                } );

            });
        })
    }

    async uploadSvgImageFile(blobimage, fileName, progressCallback = null) {
        let beforeBytes = 0
        return new Promise((resolve) => {
            var storageRef = firebase.storage().ref(FirebaseCommon.getBaseFilePath() + fileName);
            const file = new File([blobimage], fileName, { type: "image/svg+xml" })
            let upload = storageRef.put(file)
            upload.on('state_changed', function (snapshot) {
                if (progressCallback) {
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes);
                    progressCallback(progress, snapshot.bytesTransferred - beforeBytes)
                    beforeBytes = snapshot.bytesTransferred
                }
            }, function (error) {
                console.log(error)
            }, function () {
                resolve()
            });
        })
    }




    // ========== ZIP関連 ========== //
    makeZipData(){
        // 各テキストデータを保存
        var plainData = this.toJson()
        let zip = new JSZip();
        // フォルダ作成
        const folderName = this.id;
        let folder = zip.folder(folderName);
        folder.file("product.json", this.strToUtf8Array(plainData))

        // itemデータは今回はテキストデータとなるのでテキストデータのみ
        // for (var i = 0; i < this.canvasDatas.length; i++) {
        //     var canvasData = this.canvasDatas[i]
        //     for (var n = 0; n < canvasData.itemList.length; n++) {
        //         let data = await self.getCanvasItemBlob(canvasData.itemList[n])
        //         folder.file(canvasData.itemList[n].itemId + ".png", data)
        //     }
        // }
        // if (this.tagInfo == "withTag") {
        //     for (var m = 0; m < this.tagCanvasData.itemList.length; m++) {
        //         let data = await self.getCanvasItemBlob(this.tagCanvasData.itemList[m])
        //         folder.file(this.tagCanvasData.itemList[m].itemId + ".png", data)
        //     }
        // }
        return zip;
    }

    makeZipBlob(zip) {
        return new Promise(function (resolve) {
            zip.generateAsync({ type: "blob" }).then(blob => {
                resolve(blob)
            })

        })
    }

    async uploadZipFile(blobimage, fileName, progressCallback = null) {
        let beforeBytes = 0
        return new Promise((resolve) => {
            var storageRef = firebase.storage().ref(FirebaseCommon.getBaseFilePath() + fileName);
            const file = new File([blobimage], fileName, { type: "application/octet-stream" })
            let upload = storageRef.put(file)
            upload.on('state_changed', function (snapshot) {
                if (progressCallback) {
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes);
                    progressCallback(progress, snapshot.bytesTransferred - beforeBytes)
                    beforeBytes = snapshot.bytesTransferred
                }
            }, function (error) {
                console.log(error)
            }, function () {
                resolve()
            });
        })
    }

    // async downloadImageFile(url){
    //     console.log("download image :" + url);
    //     // image/svg+xml
    //     // axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
    //     //axios.defaults.withCredentials = true; 
    //     return new Promise((resolve) => {
    //         axios
    //         .get(url,{ responseType: 'arraybuffer', headers: { 'Access-Control-Allow-Headers':'*', 'Access-Control-Allow-Origin':'*', 'Access-Control-Allow-Methods':'POST, GET, PUT, OPTIONS' },})
    //         .then((response) => {
    //             resolve(response.data);
    //         })
    //         .catch(() => {
    //             resolve();
    //         });
    //     });
    // }

}




export { ProductData }